"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LANGUAGE_LOCALE_MAP = {
    en: 'en-US',
    rs: 'sr-RS',
    sr: 'sr-RS',
    cnr: 'sr-ME',
    hr: 'hr-HR',
    mk: 'mk-MK',
    ba: 'bs-BA',
    de: 'de-DE',
    al: 'sq-AL',
    sq: 'sq-AL',
    es: 'es-ES',
    fr: 'fr-FR',
    it: 'it-IT',
    ro: 'ro-RO',
    ru: 'ru-RU',
    uk: 'uk-UA',
    bg: 'bg-BG',
    pt: 'pt-PT',
    tr: 'tr-TR',
};
function getNumberLocale() {
    var lang = String(window['language'] || 'en');
    return LANGUAGE_LOCALE_MAP[lang] || lang;
}
function truncateToDecimals(value, decimals) {
    if (decimals === void 0) { decimals = 2; }
    if (!isFinite(value)) {
        return value;
    }
    var factor = Math.pow(10, decimals);
    var shifted = value * factor;
    var corrected = value >= 0 ? shifted + 1e-9 : shifted - 1e-9;
    return Math.trunc(corrected) / factor;
}
exports.truncateToDecimals = truncateToDecimals;
function parseBetAmount(value) {
    var num = parseFloat(String(value));
    if (isNaN(num)) {
        return 0;
    }
    return truncateToDecimals(num, 2);
}
exports.parseBetAmount = parseBetAmount;
function formatBetAmount(value) {
    return parseBetAmount(value).toFixed(2);
}
exports.formatBetAmount = formatBetAmount;
function formatMoneyAmount(value) {
    var num = parseFloat(String(value));
    if (isNaN(num)) {
        return value != null ? String(value) : '';
    }
    var truncated = truncateToDecimals(num, 2);
    return new Intl.NumberFormat(getNumberLocale(), {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(truncated);
}
exports.formatMoneyAmount = formatMoneyAmount;



//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/ts/helpers/format-money.ts
// module id = 234
// module chunks = 0